import React, { useState } from "react";
export interface IMergeModel {
  title: string | undefined;
  items: IMergeItemModel[];
}
export interface IMergeItemModel {
  value: string;
  type: string;
  isPrimary: boolean;
}
const MergeField: React.FunctionComponent<{
  name: string;
  onUpdate: (numbers: IMergeItemModel[]) => void;
  data: (IMergeModel | undefined)[];
  showType: boolean;
}> = (props) => {
  const [values, setValues] = useState<IMergeItemModel[]>([]);
  const onSelect = (num: IMergeItemModel) => {
    setValues((prevvalues: IMergeItemModel[]) => {
      // Check if the selected value is already in the list
      const phoneExists = prevvalues.some((phone) => phone.value === num.value);

      if (phoneExists) {
        // Remove the value if it's already present
        return prevvalues.filter((phone) => phone.value !== num.value);
      } else {
        // Add the value if it's not present
        return [...prevvalues, num];
      }
    });
  };
  const onPrimaryCheckChange = (num: IMergeItemModel) => {
    const prevValues = values;
    const valueExists = prevValues.some(
      (value) => value.value === num.value && value?.isPrimary === true
    );
    let valuePrimary = [];
    if (valueExists) {
      // Remove the phone if it's already present

      valuePrimary = [
        ...prevValues
          .filter((value) => value.value !== num.value)
          ?.map((ph) => {
            return {
              isPrimary: false,
              value: ph.value,
              type: ph.type,
            };
          }),
        { isPrimary: false, value: num.value, type: num.type },
      ];
    } else {
      // Add the phone if it's not present
      valuePrimary = [
        ...prevValues
          .filter((value) => value.value !== num.value)
          ?.map((ph) => {
            return {
              isPrimary: false,
              value: ph.value,
              type: ph.type,
            };
          }),
        { isPrimary: true, value: num.value, type: num.type },
      ];
    }
    setValues(valuePrimary);
  };
  React.useEffect(() => {
    props?.onUpdate(values);
  }, [values]);

  return (
    <>
      {props?.data
        ?.filter(
          (item) =>
            item?.items?.filter((sub) => sub?.value && sub?.value !== "")
              ?.length
        )
        ?.map(
          (contact, contactIndex) =>
            contact && (
              <div key={contactIndex} className="contact">
                <div className="row">
                  <div className="col left-wrap">
                    <p className="contact-name font-italic">{contact.title}</p>
                  </div>
                </div>
                <div>
                  {contact?.items
                    ?.filter((num) => num.value && num.value !== "")
                    .map((num, index) => {
                      // Generate unique id for each radio button and checkbox
                      const radioId = `radio_${props?.name}_${contactIndex}_${index}`;
                      const checkboxId = `checkbox_${props?.name}_${contactIndex}_${index}`;
                      return (
                        <div key={index} className="row gutter-8 mb-1">
                          <div className="col left-wrap">
                            <div className="contact-details w-100">
                              <span className="number font-sm font-weight-semibold d-flex align-items-center">
                                {num.value}
                              </span>
                              {props?.showType && (
                                <span className="type font-sm border-left font-weight-semibold d-flex align-items-center">
                                  {num.type}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-auto right-wrap d-flex align-items-center">
                            {/* Radio Button */}
                            <div className="checkbox-box border h-100">
                              <input
                                id={radioId}
                                disabled={
                                  !values.some(
                                    (value) => value.value === num.value
                                  )
                                }
                                checked={values.some(
                                  (value) =>
                                    value.value === num.value &&
                                    value?.isPrimary === true
                                )}
                                onClick={() =>
                                  onPrimaryCheckChange({
                                    isPrimary: true,
                                    type: num?.type,
                                    value: num?.value,
                                  })
                                }
                                type="radio"
                                name={props.name + "radio"}
                              />
                              <label
                                htmlFor={radioId}
                                className="pl-0 w-100 h-100 justify-content-center"
                                title="Set as Primary"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="14"
                                  height="10"
                                  viewBox="0 0 14 10"
                                  fill="none"
                                >
                                  <path
                                    d="M10.9306 0.382293L4.86025 6.45808L2.24072 3.88229C1.72802 3.3696 0.897593 3.3696 0.384624 3.88229C-0.128345 4.39499 -0.128071 5.22542 0.384624 5.73839L3.88462 9.23839C4.18759 9.4987 4.52119 9.62448 4.86025 9.62448C5.19931 9.62448 5.53181 9.49629 5.7883 9.23997L12.7883 2.23997C13.301 1.72728 13.301 0.896848 12.7883 0.383879C12.2756 -0.12909 11.4446 -0.126301 10.9306 0.382293Z"
                                    fill="#9CA3AF"
                                  />
                                </svg>
                              </label>
                            </div>

                            <div className="ml-2">
                              <input
                                type="checkbox"
                                id={checkboxId}
                                name={props.name + "checkbox"}
                                onChange={() =>
                                  onSelect({
                                    isPrimary: false,
                                    type: num?.type,
                                    value: num?.value,
                                  })
                                }
                                checked={values.some(
                                  (value) => value.value === num.value
                                )}
                              />
                              <label
                                className="pl-3"
                                htmlFor={checkboxId}
                              >
                              </label>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            )
        )}
    </>
  );
};

export default MergeField;
